// extracted by mini-css-extract-plugin
export default {"container":"FloatingActionMenu_container__VWrwl","menu":"FloatingActionMenu_menu__9dxoJ"};